import Vue from 'vue'
import VAccessComposition from '@/utils/v-access-compositions'
import VAccessDirective from '@/directives/v-access'
import { getElementsAccesses } from '@/constants/accesses'

Vue.prototype.$accesses = getElementsAccesses
Vue.prototype.$isUserGranted = VAccessComposition
Vue.directive('access', VAccessDirective())
